import { Outlet, useNavigate, useLocation, Navigate } from "react-router-dom";
import { LogOut, Home, User } from "lucide-react";
import { getWarehouseSession, clearWarehouseSession } from "@/lib/warehouseSession";

/**
 * MobileLayout — the phone shell for warehouse staff.
 *
 * No top nav from the main app. Just a slim header with the current
 * employee's name and a Home / Sign-out button. All /mobile/* routes render
 * inside this. Access is gated: no PIN session → redirect to /mobile/login.
 */
export default function MobileLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const session = getWarehouseSession();

  if (!session) {
    return <Navigate to="/mobile/login" replace state={{ from: location }} />;
  }

  const onLogout = () => {
    clearWarehouseSession();
    navigate("/mobile/login", { replace: true });
  };

  const atHome = location.pathname === "/mobile" || location.pathname === "/mobile/";

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="mobile-layout">
      <header className="sticky top-0 z-10 bg-white border-b flex items-center justify-between px-3 py-2 shadow-sm">
        <button
          onClick={() => navigate("/mobile")}
          disabled={atHome}
          className="flex items-center gap-1 text-sm font-bold text-slate-900 disabled:opacity-60"
          data-testid="mobile-home-btn"
        >
          <Home className="h-4 w-4" />
          Warehouse
        </button>
        <div className="flex items-center gap-3">
          <span className="text-xs text-slate-700 flex items-center gap-1" data-testid="mobile-employee-name">
            <User className="h-3 w-3" />
            {session.employee}
          </span>
          <button
            onClick={onLogout}
            className="text-xs text-red-600 flex items-center gap-1 font-medium"
            data-testid="mobile-logout-btn"
          >
            <LogOut className="h-3 w-3" />
            Sign out
          </button>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
